export let ContainerGradient;

(function (ContainerGradient) {
  ContainerGradient["fullPageContainer"] = "to bottom right, #F8E1EC 0%, #FDF3F3 100%";
})(ContainerGradient || (ContainerGradient = {}));

export const generateTextGradientFill = gradient => ({
  bgGradient: `linear(${gradient})`,
  bgClip: 'text'
});